import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Dashboard from 'components/dashboard/Dashboard';
import LayoutPage from 'components/layout/LayoutPage';
import AccountRoute from './AccountRoute';
import RouteChangeCanceler from './RouteChangeCanceler';
import KosoftDashboard from 'components/dashboard/KosoftDashboard';
import 'assets/styles/commonStyle.scss';
import 'assets/styles/form.scss';

const PrivateRoute: React.FC = () => {
    // ✅ Check token here — if no token, redirect to login
    const token = localStorage.getItem('token');

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div>
            <RouteChangeCanceler />
            <LayoutPage>
                <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/ko-dashboard" element={<KosoftDashboard />} />
                    <Route path='*' element={<AccountRoute />} />
                </Routes>
            </LayoutPage>
        </div>
    );
};

export default PrivateRoute;